import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 15px',
    height: '100vh',
    [theme.breakpoints.down('sm')]: { marginTop: 16, marginBottom: 8 }
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: '0 16px'
  },
  resultsContainer: {
    display: 'grid',
    height: '100vh',
    gridTemplateColumns: '3fr 1fr',
    [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr' },
    columnGap: 15
  },
  results: {
    position: 'relative',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    paddingLeft: 5,
    marginTop: 10,
    scrollbarWidth: 'none' /* Firefox */,
    msOverflowStyle: 'none' /* IE and Edge */,
    '&::-webkit-scrollbar': {
      display: 'none' /* Chrome, Safari, Opera */
    }
  },

  header: {
    display: 'flex',
    height: 60,
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginTop: 8
    }
  },
  filterBtn: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  sortContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  selectContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center'
    }
  },
  sortText: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: 5,
    alignItems: 'center'
  },
  hotels: {
    width: '100%',
    display: 'grid',
    gap: 10
  },

  noborder: {
    border: 'none'
  },

  stickyDiv: {
    position: 'sticky',
    margin: '-23px -96px -23px -96px',
    height: '100px',
    background: theme.palette.grey[800],
    top: 65,
    left: 130,
    [theme.breakpoints.down('sm')]: {
      top: 55,
      padding: '0 8px',
      margin: '-23px -16px -23px -16px',
      height: '70px'
    },
    marginBottom: 12,
    zIndex: 6
  },
  select: {
    fontSize: '14px' // or whatever size you want
  },
  noData: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(10)
  },
  headerText: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },
  imgContainer: { display: 'flex', width: '100%', height: '100%' },
  img: { width: '50%', height: '50%' },
  noResultFound: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing(5)
  },

  filterTitle: {
    color: theme.palette.text.primary,
    fontSize: 16
  },
  noresult: {
    width: '25%',
    [theme.breakpoints.down('sm')]: {
      width: '35%'
    }
  },
  noResults: {
    marginTop: 16,
    fontWeight: 500,
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  }
}))
export default useStyles
